/**
 * Pending Withdraw Collection
 */

define(function(require, exports, module) {
    'use strict';

    var BaseCollection = require('common/base.collection');
    var server = require('server');
    var PendingItemModel = require('portlets/cashier/pending/pending.item.model');

    module.exports = BaseCollection.extend({

        model: PendingItemModel,

        comparator: function(model) {
            return -Number(new Date(model.get('time')));
        },

        parse: function(response) {
            return response.data.payments && response.data.payments.transaction;
        },

        /**
         * Get sum of all pending withdrawals
         * @return {number}
         */
        getSum: function() {
            return this.reduce(function(sum, model) {
                return sum + model.get('amount');
            }, 0);
        },

        getRequestData: function() {
            return {
                ID: 33026,
                description: 'Get Transaction history',
                responses: [33027, 33028],
                type: 'Withdraw',
                status: 'Pending',
                corrections: true
            };
        },

        sync: function(method, collection, options) {
            if (method === 'read') {
                var request = this.getRequestData();

                return server.send(request)
                    .done(options.success).fail(options.error);
            }
        }
    });
});